import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { IconTitle, PageLayouts, ReloadEvent, TitleIcon } from "components/common";
import { Grid } from "@mui/material";
import AdvisoryViewDashboardContent from "./dashboardContent";
import useAdvisorPermissions from "./usePermissions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const AdvisorDashboard: React.FC = () => {
  const { advisorViewsAvailable } = useAdvisorPermissions();

  return (
    <ReloadEvent
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout
          entityKey={0}
          hasPermissions={advisorViewsAvailable}
          className={cssExports.advisorDashboard}
          title={
            <IconTitle
              title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.AdvisoryView)}
              icon={<TitleIcon icon={IconDefinitionConstants.WCompany} />}
            ></IconTitle>
          }
          // topRightButtons={<AdvisoryViewButtons />}
          // Buttons - enable with the second release
          // To Do: clarify permissions for the auditor, when working on these buttons
        >
          <Grid container item>
            <AdvisoryViewDashboardContent />
          </Grid>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default AdvisorDashboard;
